import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {WildExpansionView} from "../wildexpansion/WildExpansionView";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";

/**
 * Created by Jerker Nord on 2020-05-08.
 */

export class BonusBunniesBonusFillUpMeterWPController extends WinPresentationController{

    private _totalBonusWinMultiplierBefore:number = 0;
    private _totalBonusWinMultiplierAfter:number = 0;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "BonusBunniesBonusFillUpMeterWPController", skippable : false});
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._totalBonusWinMultiplierAfter = data.totalBonusWinMultiplierAfter;
        this._totalBonusWinMultiplierBefore = data.totalBonusWinMultiplierBefore;
    }

    protected hasWin():boolean {
        if(
            (this._totalBonusWinMultiplierAfter > 0) &&
            (this._gameData!.nextMode == BonusBunniesGameMode.BONUS_GAME) ||
            (this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME && this._gameData!.nextMode == BonusBunniesGameMode.NORMAL)) {
            return true;
        }
        return false;
    }

    protected startWinPresentation():void {
        if(this._gameData!.mode == BonusBunniesGameMode.BONUS_GAME) {
            BonusBunniesGameModuleConfig.bonusBunniesBonusSpinsCounterController.playFillUpMeterAnimation();
        }
        this.finish();
    }

    protected stopWinPresentation(isAborted:boolean):void {

    }
}